export const selfRegistrationMsg = {
  email: 'self-registered@user.com',
  id: 200,
  userId: 100,
};

export const vitalsData = [
  {
    archive: false,
    id: 122839,
    variableId: 49,
    value: {
      value: '55',
    },
    userId: 8262,
    createdBy: 8262,
    updatedBy: 8262,
    priority: '4',
    dateTime: '2022-03-21T19:35:29.766Z',
    createdAt: '2022-03-21T19:35:29.766Z',
    updatedAt: '2022-03-21T19:35:29.766Z',
    migratedAt: null,
    vitalId: null,
  },
  {
    archive: false,
    id: 122840,
    variableId: 50,
    value: {
      value: '5.8',
    },
    userId: 8262,
    createdBy: 8262,
    updatedBy: 8262,
    priority: '4',
    dateTime: '2022-03-21T19:35:29.766Z',
    createdAt: '2022-03-21T19:35:29.766Z',
    updatedAt: '2022-03-21T19:35:29.766Z',
    migratedAt: null,
    vitalId: null,
  },
];

export const selfRegisteredUser = {
  data: {
    user_detail: {
      id: 284,
      firstName: 'Test Name',
      lastName: 'Test LastName',
      gender: 1,
      birthDate: '1947-07-19',
      city: null,
      userId: 1,
      addressLine1: null,
      addressLine2: null,
      mobilePhone: null,
      homePhone: null,
      extension: null,
      termId: 1,
      accountInfoStatus: 1,
      createdAt: '2020-04-21T14:59:27.228Z',
      updatedAt: '2021-03-02T19:47:26.361Z',
      createdBy: null,
      updatedBy: 173,
      countryId: null,
      stateId: null,
      zipCodeId: null,
      fullName: 'Test Name Test LastName',
    },
    user_roles: [
      {
        id: 152,
        userId: 1,
        roleId: 4,
        createdAt: '2020-04-21T14:59:35.241Z',
        updatedAt: '2020-04-21T14:59:35.241Z',
        createdBy: null,
        updatedBy: null,
        role: {
          id: 4,
          name: 'Patient',
          slug: 'patient',
          description: 'patient',
          parentId: null,
          group: 'Patient',
          createdAt: '2020-02-28T11:38:51.180Z',
          updatedAt: '2020-02-28T11:38:51.180Z',
          createdBy: null,
          updatedBy: null,
          role_actions: [],
        },
        name: 'Patient',
        userRoleId: 152,
        group: 'Patient',
        slug: 'patient',
      },
    ],
    id: 1,
    email: 'test.test@patient.com',
    newEmail: 'test1@patient.com',
    isSelfEnrolled: true,
    isVerifiedNewEmail: false,
    oldActivatedEmail: 'test@patient.com',
    isVerified: true,
    verifiedDate: '2020-04-21T15:00:55.219Z',
    verifyToken: '8d9d871a2796c7ffd9bd2995d75a6b',
    verifyExpires: '2021-02-26T20:13:03.133Z',
    resetToken: '$2b$11$IaAHeV1m6I3WYziMlYotEulclbhEjpyRNyzoj5A/5awz56UNqamWO',
    resetExpires: '2020-11-03T14:10:35.373Z',
    lastIpAddress: '::1',
    currentIpAddress: '::1',
    timezone: 'Asia/Yerevan',
    accountsExpired: false,
    isWorkFactorChanged: true,
    accountLocked: false,
    credentialsExpired: false,
    accountEnabled: true,
    type: 'patient',
    isUserReminded: 'never-reminded',
    loginAttempts: 0,
    deduUserId: 191087,
    bmiqUserId: null,
    migratedAt: null,
    migrateMessageShowed: false,
    isSubscribed: true,
    accountAccessToken: '982a1209ee051262f50182bd2931db',
    twoFaAccessToken: null,
    authSecret: null,
    authEnabled: false,
    authType: null,
    allowedFeatures: [],
    isTestUser: false,
    createdAt: '2020-04-21T14:59:27.193Z',
    updatedAt: '2021-03-09T14:31:05.950Z',
    createdBy: null,
    updatedBy: 173,
    fullName: 'Test Name Test LastName',
    associations: {
      Patient: {
        organizations: [
          {
            id: 1,
            name: 'Test Medical Center',
            active: true,
            siteId: 1027,
            address: null,
            city: null,
            subdomain: null,
            useReverseProxy: false,
            timezone: null,
            authEnabled: false,
            createdAt: '2020-04-30T15:07:17.624Z',
            updatedAt: '2020-12-15T09:36:24.205Z',
            createdBy: null,
            updatedBy: 1,
            ownerId: 199,
            countryId: null,
            stateId: null,
            zipCodeId: null,
            'organizations_patients.patientId': 10,
            'organizations_patients.organizationId': 40,
            'organization_ehr_platforms.id': null,
            'organization_ehr_platforms.ehrPlatformId': null,
          },
        ],
        providers: [
          {
            id: 41,
            email: 'provider@test.com',
            timezone: null,
            firstName: 'Alice',
          },
        ],
        patient: {
          id: 1,
          wellnessVision: '',
          enrollmentDate: '2020-04-21T14:59:27.233Z',
          lastContact: '2021-03-09T10:31:05.960Z',
          createdAt: '2020-04-21T14:59:27.233Z',
          updatedAt: '2021-03-09T14:31:05.960Z',
          userId: 1,
          createdBy: null,
          updatedBy: 173,
          patientAvailabilityId: null,
          programId: 1,
          patientGoalId: null,
        },
      },
    },
  },
  OTToken: '46472562',
};
